import React, {useEffect, useRef} from 'react';
import {
  View,
  ScrollView,
  Image,
  TouchableOpacity,
  StyleSheet,
  ImageBackground,
  Animated,
} from 'react-native';
import {downloadApk} from '@/utils';
import {stopBeforeDownload} from '@/utils/utils';
import theme from '@/style';
const Invitation = () => {
  const scaleAnim = useRef(new Animated.Value(1)).current;
  const carouselAnim = useRef(new Animated.Value(0)).current;

  const toDownload = () => {
    if (stopBeforeDownload()) {
      return;
    }
    downloadApk();
  };

  useEffect(() => {
    // Create a continuous scaling animation
    Animated.loop(
      Animated.sequence([
        Animated.timing(scaleAnim, {
          toValue: 1.2,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(scaleAnim, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
      ]),
    ).start();

    // Create auto-carousel animation for bottom images
    // 7个图片，每个宽度115px (bottomImage尺寸)
    const itemWidth = 115;
    Animated.loop(
      Animated.sequence([
        Animated.timing(carouselAnim, {
          toValue: -itemWidth * 7, // 滚动7个图片的宽度
          duration: 30000, // 调整时长 - 更慢的动画速度
          useNativeDriver: true,
        }),
        Animated.timing(carouselAnim, {
          toValue: 0,
          duration: 0,
          useNativeDriver: true,
        }),
      ]),
    ).start();
  }, [scaleAnim, carouselAnim]);

  const styles = StyleSheet.create({
    banner: {
      height: 60,
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.paddingSize.l,
      paddingVertical: theme.paddingSize.s,
      background: 'linear-gradient(90deg, #EB9D00 0%, #C15D00 100%)',
    },
    bannerGradient: {
      backgroundColor: '#EB9D00', // 退降级背景色
    },
    logoImage: {
      width: 40,
      height: 40,
      marginRight: 12,
    },
    downloadButton: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 20,
      paddingHorizontal: theme.paddingSize.m,
      paddingVertical: theme.paddingSize.xs,
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    downloadBg: {
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
    closeButton: {
      marginLeft: theme.paddingSize.m,
    },
    closeIcon: {
      width: 20,
      height: 20,
    },
    scrollContent: {
      flexGrow: 1,
    },
    imageAspect1: {
      aspectRatio: 375 / 336,
      width: '100%',
    },
    imageAspect2: {
      position: 'relative',
      aspectRatio: 375 / 411,
      width: '100%',
    },
    bg: {
      backgroundColor: '#000',
    },
    imageAspect3: {
      position: 'relative',
      aspectRatio: 375 / 571,
      width: '100%',
    },
    logoContainer: {
      position: 'absolute',
      top: 20,
      left: 0,
      right: 0,
      alignItems: 'center',
      borderRadius: 8,
      display: 'none',
    },
    logoBox: {
      width: 119,
      height: 23,
      borderWidth: 1,
      borderColor: '#C19F55',
      borderRadius: 6,
      backgroundColor: '#000700',
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 4,
    },
    logoImage1: {
      width: 22,
      height: 21,
      marginRight: 4,
    },
    plinkobetTextImage: {
      flex: 1,
      height: 20,
    },
    carouselContainer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 140,
      overflow: 'hidden',
      paddingBottom: theme.paddingSize.s,
    },
    carouselContent: {
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
    gameItem: {
      position: 'relative',
      width: 115,
      height: 115,
      marginHorizontal: 0,
      alignItems: 'center',
      justifyContent: 'center',
    },
    hotImage: {
      position: 'absolute',
      top: 25,
      left: 0,
      zIndex: 9,
      width: 46,
      height: 16,
    },
    bottomImagesContainer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'flex-end',
      paddingHorizontal: theme.paddingSize.m,
      paddingBottom: theme.paddingSize.s,
    },

    bottomImage: {
      width: 115,
      height: 115,
    },
    gameText1: {
      width: 77,
      height: 16,
    },
    gameText2: {
      width: 84,
      height: 17,
    },
    gameText3: {
      width: 76,
      height: 17,
    },
    bg2Content: {
      position: 'relative',
      paddingTop: 120,
      alignItems: 'center',
    },
    coin1Image: {
      position: 'absolute',
      width: 63,
      height: 89,
      left: 0,
      bottom: -193,
    },
    coin2Image: {
      position: 'absolute',
      width: 50,
      height: 74,
      right: 0,
      bottom: -250,
    },
    imageAspect4: {
      aspectRatio: 375 / 519,
      width: '100%',
    },
    text1Image: {
      width: 324,
      height: 61,
      marginBottom: theme.paddingSize.m,
    },
    rewardImage: {
      width: 252,
      height: 34,
      marginTop: 8,
      marginBottom: 28,
    },
    downloadImage: {
      width: 212,
      height: 42,
      marginVertical: theme.paddingSize.m,
    },
    listPor: {
      position: 'relative',
      zIndex: 9,
      height: 50,
      backgroundColor: '#000',
    },
    gradientLayer1: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9,
      backgroundColor: 'rgba(0, 0, 0, 1)',
      height: '30%',
    },
    gradientLayer2: {
      position: 'absolute',
      top: '30%',
      left: 0,
      right: 0,
      backgroundColor: 'rgba(15, 12, 7, 0.7)',
      height: '40%',
    },
    gradientLayer3: {
      position: 'absolute',
      top: '70%',
      left: 0,
      right: 0,
      backgroundColor: 'rgba(31, 24, 14, 0.3)',
      height: '30%',
    },
    gradientLayer4: {
      position: 'absolute',
      top: '90%',
      left: 0,
      right: 0,
      backgroundColor: 'rgba(31, 24, 14, 0)',
      height: '10%',
    },
    listScrollView: {
      position: 'absolute',
      top: -224,
      left: 0,
      right: 0,
      zIndex: 9,
    },
    listContainer: {
      flexDirection: 'row',
      paddingHorizontal: 12,
      gap: 8,
    },
    listImage: {
      width: 218,
      height: 275,
    },
    modulesContainer: {
      position: 'relative',
      backgroundColor: '#0B0F1C',
    },
    coin4: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 63,
      height: 89,
    },
    coin5: {
      position: 'absolute',
      top: 45,
      right: 0,
      width: 50,
      height: 74,
    },
    text3Image: {
      width: '100%',
      height: 72,
      marginBottom: theme.paddingSize.l,
    },
    stepBgImage: {
      width: '100%',
      height: 252,
      marginBottom: theme.paddingSize.l,
    },
    featuresScrollView: {
      marginTop: -148, // Align with bg4 bottom (negative margin to overlap)
    },
    featuresScrollContent: {
      paddingHorizontal: theme.paddingSize.m,
      gap: 8,
    },
    featureCardImage: {
      width: 214,
      height: 148,
      marginRight: 8,
    },
    bg5Image: {
      width: '100%',
      aspectRatio: 375 / 354,
      marginTop: theme.paddingSize.l,
    },
    downloadImage2: {
      width: 212,
      height: 42,
      marginTop: -75,
      alignSelf: 'center',
    },
  });

  return (
    <View style={[theme.flex.flex1, theme.background.white]}>
      <ScrollView
        style={[theme.flex.flex1]}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}>
        {/* 背景图片1 - 375 x 371 */}
        <ImageBackground
          source={require('@/assets/imgs/invitation/bg1.webp')}
          style={styles.imageAspect1}
          resizeMode="cover">
          {/* Plinkobet Logo 组件 */}
          <View style={styles.logoContainer}>
            <View style={styles.logoBox}>
              <Image
                source={require('@/assets/imgs/invitation/logo1.png')}
                style={styles.logoImage1}
                resizeMode="contain"
              />
              <Image
                source={require('@/assets/imgs/invitation/Plinkobet.png')}
                style={styles.plinkobetTextImage}
                resizeMode="contain"
              />
            </View>
          </View>

          {/* 底部游戏轮播图片 */}
          <View style={styles.carouselContainer}>
            <Animated.View
              style={[
                styles.carouselContent,
                {
                  transform: [{translateX: carouselAnim}],
                },
              ]}>
              {/* 第一组图片 */}
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/aviator.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/chickenRoad.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/jackpot.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/pappu.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/tri.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/up7.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/vortex.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              {/* 复制第一组图片，实现无缝轮播 */}
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/aviator.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/chickenRoad.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
              <View style={styles.gameItem}>
                <Image
                  source={require('@/assets/imgs/invitation/hot.webp')}
                  style={styles.hotImage}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/assets/imgs/invitation/jackpot.png')}
                  style={styles.bottomImage}
                  resizeMode="contain"
                />
              </View>
            </Animated.View>
          </View>
        </ImageBackground>
        {/* 背景图片2 - 375 x 411 */}
        <ImageBackground
          source={require('@/assets/imgs/invitation/bg2.webp')}
          style={styles.imageAspect2}
          resizeMode="cover">
          <View style={styles.bg2Content}>
            <Animated.View style={{transform: [{scale: scaleAnim}]}}>
              <TouchableOpacity onPress={toDownload}>
                <Image
                  source={require('@/assets/imgs/invitation/download.webp')}
                  style={styles.downloadImage}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </Animated.View>
          </View>
        </ImageBackground>
        <View style={styles.listPor}>
          <View style={styles.gradientLayer1} />
          <View style={styles.gradientLayer2} />
          <View style={styles.gradientLayer3} />
          <View style={styles.gradientLayer4} />
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={styles.listScrollView}>
            <View style={styles.listContainer}>
              <Image
                source={require('@/assets/imgs/invitation/list1.png')}
                style={styles.listImage}
                resizeMode="contain"
              />
              <Image
                source={require('@/assets/imgs/invitation/list2.png')}
                style={styles.listImage}
                resizeMode="contain"
              />
              <Image
                source={require('@/assets/imgs/invitation/list3.png')}
                style={styles.listImage}
                resizeMode="contain"
              />
              <Image
                source={require('@/assets/imgs/invitation/list4.png')}
                style={styles.listImage}
                resizeMode="contain"
              />
            </View>
          </ScrollView>
        </View>
        {/* 背景图片3 - 375 x 595 */}
        <View style={styles.bg}>
          <ImageBackground
            source={require('@/assets/imgs/invitation/bg3.webp')}
            style={styles.imageAspect3}
            resizeMode="cover"
          />
        </View>
        {/* 4模块 */}
        <View style={styles.modulesContainer}>
          <ImageBackground
            source={require('@/assets/imgs/invitation/bg4.webp')}
            style={styles.imageAspect4}
            resizeMode="cover"
          />
          {/* Features horizontal list */}
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={styles.featuresScrollView}
            contentContainerStyle={styles.featuresScrollContent}>
            {/* Instant Transfer */}
            <Image
              source={require('@/assets/imgs/invitation/tran.webp')}
              style={styles.featureCardImage}
              resizeMode="contain"
            />
            {/* Safety And Security */}
            <Image
              source={require('@/assets/imgs/invitation/safe.webp')}
              style={styles.featureCardImage}
              resizeMode="contain"
            />
            {/* VIP Perks */}
            <Image
              source={require('@/assets/imgs/invitation/vip.webp')}
              style={styles.featureCardImage}
              resizeMode="contain"
            />
            {/* Targeted Suggestions */}
            <Image
              source={require('@/assets/imgs/invitation/suggest.webp')}
              style={styles.featureCardImage}
              resizeMode="contain"
            />
          </ScrollView>

          {/* 模块5 - 背景图片4 */}
          <TouchableOpacity onPress={toDownload}>
            <Image
              source={require('@/assets/imgs/invitation/bg5.webp')}
              style={styles.bg5Image}
              resizeMode="cover"
            />
            <Image
              source={require('@/assets/imgs/invitation/download.webp')}
              style={styles.downloadImage2}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </ScrollView>
    </View>
  );
};

export default Invitation;
